import { CarFrontIcon, CoinsIcon, FileSpreadsheetIcon, FileStackIcon, FileTextIcon, GitForkIcon, HandshakeIcon, TablePropertiesIcon, TicketIcon, User2Icon } from "lucide-react";
import { usePermittedReports } from "@/features/reports/hooks/usePermittedReports";
import { SearchableModel } from "../types/searchableModel.type";
import { PermittedReportsTransformer } from "@/features/reports/services/permittedReportsTransformer";
import { useSupportTickets } from "@/features/support/hooks/useSupportTickets";
import { SupportTicketsTransformer } from "@/features/support/services/supportTicketsTransformer";
import { useBillingEvents } from "../hooks/queries/useBillingEvents";
import { useClientUsers } from "@/features/users/hooks/useClientUsers";
import { ClientUsersTransformer } from "@/features/users/services/clientUsersTransformer";
import { useEquipments } from "@/features/equipments/hooks/useEquipments";
import { EquipmentsTransformer } from "@/features/equipments/services/equipmentTransformer";
import { useBillingBills } from "../hooks/queries/useBillingBills";
import { BillsTransformer } from "@/features/billingBills/services/billsTransformer";
import { BillingEventTransformer } from "@/features/billingEvents/services/billingEventTransformer";
import { useNegotiations } from "@/features/negotiations/hooks/useNegotiations";
import { NegotiationsTransformer } from "@/features/negotiations/services/NegotiationsTransformer";
import { useBillingEventsWithFiscalDocumentRequirement } from "@/features/billing/hooks/useBillingEventWithFiscalDocumentRequirement";
import { useBillingFiscalDocumentGroups } from "@/features/billing/hooks/useBillingFiscalDocumentGroups";
import { BillingEventsFiscalDocumentsTransformer } from "@/features/billing/services/eventsFiscalDocumentsTransformer";
import { BillingFiscalDocumentGroupsTransformer } from "@/features/billing/services/fiscalDocumentGroupsTransformer";
import { useBranches } from "../hooks/queries/useBranches";
import { CompanyBranchesTransformer } from "@/features/companyBranches/services/companyBranchesTransformer";
import { useGovernmentAllocations } from '@/features/governmentAllocations/hooks/useGovernmentAllocations'
import { GovernmentAllocationTransformer } from "@/features/governmentAllocations/services/governmentAllocationsTransformer";

export const searchableModels: (companyKind?: string) => SearchableModel[] = (companyKind) => {
  const models = [
    {
      label: 'Equipamentos',
      icon: CarFrontIcon,
      hook: useEquipments,
      mapper: EquipmentsTransformer.quickSearchModelTransformer,
    },
    {
      label: 'Usuários',
      icon: User2Icon,
      hook: useClientUsers,
      mapper: ClientUsersTransformer.quickSearchModelTransformer,
    },
    {
      label: 'Faturas',
      icon: FileTextIcon,
      hook: useBillingBills as SearchableModel['hook'],
      mapper: BillsTransformer.quickSearchModelTransformer,
    },
    {
      label: 'Transações',
      icon: FileTextIcon,
      hook: useBillingEvents,
      mapper: BillingEventTransformer.quickSearchModelTransformer,
    },
    {
      label: 'Recolha de notas fiscais por transação',
      icon: CoinsIcon,
      hook: useBillingEventsWithFiscalDocumentRequirement,
      mapper: BillingEventsFiscalDocumentsTransformer.quickSearchModelTransformer,
    },
    {
      label: 'Recolha de notas fiscais por lote',
      icon: TablePropertiesIcon,
      hook: useBillingFiscalDocumentGroups,
      mapper: BillingFiscalDocumentGroupsTransformer.quickSearchModelTransformer,
    },
    {
      label: 'Filiais (Estrutura)',
      icon: GitForkIcon,
      hook: useBranches,
      mapper: CompanyBranchesTransformer.quickSearchModelTransformer,
    },
    {
      label: 'Relatórios',
      icon: FileSpreadsheetIcon,
      hook: usePermittedReports,
      mapper: PermittedReportsTransformer.quickSearchModelTransformer,
    },
    {
      label: 'Chamados',
      icon: TicketIcon,
      hook: useSupportTickets,
      mapper: SupportTicketsTransformer.quickSearchModelTransformer,
    },
  ];

  if (companyKind === 'private_company') {
    models.splice(4, 0, {
      label: 'Negociações',
      icon: HandshakeIcon,
      hook: useNegotiations,
      mapper: NegotiationsTransformer.quickSearchModelTransformer as SearchableModel['mapper'],
    });
  }

  if (companyKind === 'public_company') {
    models.splice(4, 0, {
      label: 'Empenhos',
      icon: FileStackIcon,
      hook: useGovernmentAllocations as any,
      mapper: GovernmentAllocationTransformer.quickSearchModelTransformer as SearchableModel['mapper'],
    });
  }

  return models;
};
